<template>
    <client-page class="wrap--join">
        <div class="container">
            <h2 class="join-title">회원가입</h2>

            <div class="join-container">
                <div class="join-gate">
                    <!-- 개인 -->
                    <div class="join-gate-box join-gate-box--personal">
                        <div class="join-gate-box__inner">
                            <h2>개인회원</h2>
                            <i class="icon icon-chair"></i>
                            <dialog-join :userType="PERSON.value">
                                <template #activator="{ attrs, on }"> <v-btn color="primary" v-bind="attrs" v-on="on"> 가입하기 </v-btn> </template>
                            </dialog-join>
                            <!-- <v-btn :to="{ path: '/join/form', query: { code: PERSON.value } }" color="primary"> 가입하기 </v-btn> -->
                        </div>
                    </div>
                    <!-- 업체 -->
                    <div class="join-gate-box join-gate-box--business">
                        <div class="join-gate-box__inner">
                            <h2>기업회원</h2>
                            <i class="icon icon-picture"></i>
                            <dialog-join :userType="COMPANY.value">
                                <template #activator="{ attrs, on }"> <v-btn color="primary" v-bind="attrs" v-on="on"> 가입하기 </v-btn> </template>
                            </dialog-join>
                            <!-- <v-btn :to="{ path: '/join/form', query: { code: COMPANY.value } }" color="primary"> 가입하기 </v-btn> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import { USER_TYPES } from "@/assets/variables";
import DialogJoin from "@/components/client/join/dialog-join/dialog-join.vue";
const { PERSON, COMPANY } = USER_TYPES;

export default {
    components: {
        ClientPage,
        DialogJoin,
    },
    data: () => ({
        PERSON,
        COMPANY,
    }),
};
</script>
